import { APP_INITIALIZER, EnvironmentProviders, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { catchError, firstValueFrom, of } from 'rxjs';
import { UserSettingsModels } from '@share-models';

const uiLangs = Object.values(UserSettingsModels.LANGUAGE) as UserSettingsModels.LANGUAGE[];

export function uiTranslationsInitializer(
  translateService: TranslateService,
  http: HttpClient,
): () => Promise<void> {
  return () => {
    const requests = uiLangs.map((lang) => {
      const url = `assets/ui/i18n/${lang}.json?v=${Date.now()}`;
      return firstValueFrom(
        http
          .get<TranslationObject>(url)
          .pipe(catchError(() => of({} as TranslationObject))),
      ).then((translations) => {
        translateService.setTranslation(lang, translations ?? {}, true);
      });
    });

    return Promise.all(requests).then(() => undefined);
  };
}

export function provideUiTranslations(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: uiTranslationsInitializer,
      deps: [TranslateService, HttpClient],
    },
  ];
}
